/* eslint-disable */
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Glyphicon } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch } from '../../utils/util';
import Highlighter from "react-highlight-words";

import OzFormComponent from './OzFormComponent';
import WhereField from './WhereField';
import './LocationForm.css';

import {
  listRegions,
} from '../../actions';


class RegionForm extends OzFormComponent {
  static fields = [
    'regionId',
  ];

  constructor(props) {
    super(props);
    console.log('RegionForm got props', props);
    this.state.regionId = props.values.id;
  }

  getValues() {
    let values = super.getValues();
    console.log('RegionForm returning values', values, this.props);
    return values;
  }

  renderBody() {
    let regionOptions = this.props.regions.map(region => [region.id, region.name]);

    return (
      <div className="RegionForm">
        {this.renderFormGroup('Region', 'select', 'regionId', regionOptions)}
      </div>
    );
  }
}


class LocationForm extends OzFormComponent {

  static fields = [
    'address',
    'regions',
  ];

  options = {
    regions: {
      init: {}
    },
  }

  componentDidMount() {
    console.log('LocationForm got values:', this.props.values);
    this.props.listRegions();
  }

  getValues() {
    let values = super.getValues();
    if (values.regions) {
      // TODO: nasty hack below
      let regionIds = values.regions.map(r => r.regionId || r.id);
      console.log('got regionIds', regionIds, values.regions);
      delete values.regions;
      values.regionIds = regionIds;
    } else {
    }
    return values;
  }

  setWhere(where) {
    console.log('where:', where);
    this.setState({ address: where.name })
  }

  renderRegions() {
    // let regions = this.props.regions ? this.props.regions.items : [];
    let regions = this.state.regions || [];
    let i = 0;
    let nodes = regions.map(region => {
      let index = i;
      i++;
      let errors = ((this.props.errors && this.props.errors.regions)
          ? this.props.errors.regions[index] : null)
      return (
        <RegionForm
          key={region.id}
          index={region.id}
          errors={errors}
          part={true}
          values={region}
          cancelRender={() => <Glyphicon className="minus-sign" glyph="minus-sign" />}
          onCancel={() => this.removeMany(region.id, 'regions')}
          onChange={(values) => this.updateMany(region.id, values, 'regions')}

          regions={this.props.regions ? this.props.regions.items : []}
        />
      );
    });

    return (
      <div className="regions-wrapper">
        {nodes}
      </div>
    );
  }

  renderBody() {
    return (
      <div className="LocationForm">
        <FormGroup>
          <ControlLabel>Address</ControlLabel>
          <HelpBlock>Enter the address of this location</HelpBlock>
          <WhereField
            prefill={this.props.values.address}
            onChange={(where) => this.setWhere(where)}
            onSelect={(where) => this.setWhere(where)}
          />
        </FormGroup>

        {!this.props.noRegions && this.renderRegions()}
        {!this.props.noRegions && <div className="add-region">
          <Button onClick={() => this.addMany('regions')}>Add Region</Button>
        </div>}

      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    regions: state.list.region,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    listRegions,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LocationForm);



/** WEBPACK FOOTER **
 ** ./src/components/partials/LocationForm.js
 **/